export const formatNumber = (value: number) => {
  if (typeof window !== 'undefined' && window.Intl) {
    return Intl.NumberFormat('ru').format(value);
  }

  return value;
};
